import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';

import { fuseAnimations } from '@fuse/animations';

import { Question } from 'app/models/question.model';
import { PreguntasService } from 'app/main/preguntas/preguntas.service';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector     : 'preguntas-list',
    templateUrl  : './preguntas-list.component.html',
    styleUrls    : ['./preguntas-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class PreguntasListComponent implements OnInit, OnDestroy
{
    preguntas: Question[];
    currentPregunta: Question;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param _activatedRoute
     * @param _preguntasService
     * @param _location
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _preguntasService: PreguntasService,
        private _location: Location
    )
    {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Subscribe to update todos on changes
        this._preguntasService.onPreguntasChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(preguntas => {
                this.preguntas = preguntas;
            });

        // Subscribe to update current todo on changes
        this._preguntasService.onCurrentPreguntaChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(currentPregunta => {
                if ( !currentPregunta )
                {
                    // Set the current todo id to null to deselect the current todo
                    this.currentPregunta = null;

                    // Handle the location changes
                    const tagHandle    = this._activatedRoute.snapshot.params.tagHandle;
                    const filterGroup = this._activatedRoute.snapshot.params.filterGroup;

                    /*
                    if ( tagHandle )
                    {
                        this._location.go('preguntas/tag/' + tagHandle);
                    }
                    else*/
                    if ( filterGroup )
                    {
                        this._location.go('preguntas/filter/' + filterGroup);
                    }
                    else
                    {
                        this._location.go('preguntas/all');
                    }
                }
                else
                {
                    this.currentPregunta = currentPregunta;
                }
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Read todo
     *
     * @param todoId
     */
    readPregunta(todoId): void
    {
        // Set current todo
        this._preguntasService.setCurrentPregunta(todoId);
    }

    /**
     * On drop
     *
     * @param ev
     */
    onDrop(ev): void
    {

    }
}
